import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = { class: "password-input" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = { class: "password-input" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_20 = { class: "password-input" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "col-md-12" }
const _hoisted_23 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_24 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_25 = { class: "row justify-content-center" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" PASSWORD "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('form.current_password.label')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.current_password) = $event)),
                    type: "password",
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.currentPasswordIsValid }]]),
                    required: "",
                    placeholder: _ctx.$t('form.current_password.placeholder')
                  }, null, 10 /* CLASS, PROPS */, _hoisted_8), [
                    [_vModelText, _ctx.form.current_password]
                  ]),
                  _createElementVNode("i", {
                    class: "ph ph-eye position-absolute top-0 end-0 fs-18 text-muted",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePassword($event)))
                  })
                ]),
                (_ctx.errors?.current_password ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.current_password, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_10,
            _createCommentVNode(" PASSWORD "),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('form.password.label')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.password) = $event)),
                    type: "password",
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.passwordIsValid }]]),
                    required: "",
                    placeholder: _ctx.$t('form.password.placeholder')
                  }, null, 10 /* CLASS, PROPS */, _hoisted_15), [
                    [_vModelText, _ctx.form.password]
                  ]),
                  _createElementVNode("i", {
                    class: "ph ph-eye position-absolute top-0 end-0 fs-18 text-muted",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePassword($event)))
                  })
                ]),
                (_ctx.errors?.password ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.password, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" PASSWORD_CONFIRMATION "),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('form.password_confirmation.label')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password_confirmation) = $event)),
                    type: "password",
                    class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && (!_ctx.passwordIsValid || !_ctx.confirmPasswordIsValid) }]]),
                    required: "",
                    placeholder: _ctx.$t('form.password_confirmation.placeholder')
                  }, null, 10 /* CLASS, PROPS */, _hoisted_21), [
                    [_vModelText, _ctx.form.password_confirmation]
                  ]),
                  _createElementVNode("i", {
                    class: "ph ph-eye position-absolute top-0 end-0 fs-18 text-muted",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.togglePassword($event)))
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createCommentVNode(" SAVE "),
                  _createElementVNode("div", _hoisted_24, [
                    (!_ctx.force)
                      ? (_openBlock(), _createBlock(_component_DiscardButton, {
                          key: 0,
                          onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ path: '/profile' })))
                        }))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                      type: "submit",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setPristine && _ctx.setPristine(...args)))
                    }, _toDisplayString(_ctx.$t('cta.update_password')), 1 /* TEXT */)
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 }))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "alertModal",
      title: _ctx.$t('cta.update_password'),
      message: _ctx.$t('feature.auth.$update_password.success_message'),
      onConfirm: _ctx.redirect,
      dismissible: false
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"]),
    _createVNode(_component_AlertModal, {
      id: "forceModal",
      title: _ctx.$t('cta.update_password'),
      message: _ctx.firstAccess === true ? _ctx.$t('feature.auth.$update_password.first_access') : _ctx.$t('feature.auth.$update_password.force_message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}